import type { SourceLanguageCode } from '@ellie/shared';
import { SOURCE_LANGUAGES, parseHighlightedHint } from '@ellie/shared';

interface NativeHintProps {
  text: string;
  nativeLanguage: SourceLanguageCode;
  /** Override the badge label (e.g. pass target language code for instructionsNative). */
  label?: string;
}

/**
 * Renders a native-language hint with a dynamic language label
 * (e.g. "NL" for Dutch, "EN" for English). Words wrapped in **double
 * asterisks** are rendered as bold + underlined to highlight the answer word.
 */
export function NativeHint({ text, nativeLanguage, label: labelOverride }: NativeHintProps) {
  const lang = SOURCE_LANGUAGES.find((l) => l.code === nativeLanguage);
  const label = labelOverride ?? (lang ? lang.code.toUpperCase() : nativeLanguage.toUpperCase());
  const segments = parseHighlightedHint(text);

  return (
    <span className="wb-native-tag">
      <span className="wb-native-tag-label">{label}</span>
      {segments.map((seg, i) =>
        seg.highlighted ? (
          <strong key={i} className="wb-hint-highlight">
            {seg.text}
          </strong>
        ) : (
          <span key={i}>{seg.text}</span>
        ),
      )}
    </span>
  );
}
